import { Descriptions } from 'antd';
import dayjs from 'dayjs';
import React from 'react';

import Title from 'components/atoms/Title';
import TranslateText from 'components/hoc/TranslateText';
import FormWrapper from 'components/molecules/FormWrapper';

import { ILeiDetail } from 'services/lei/leiSeznam';

import { leiElfKodySelect } from 'data/codebooks/lei/leiElfKodySelect';
import { leiRejstrikySelect } from 'data/codebooks/lei/leiRejstrikySelect';

interface ILeiSeznamPridelenychLei {
    data: ILeiDetail | undefined;
}

const getBackGroundStyle = (index: number) => {
    return index % 2
        ? {
              background: '#f2f2f2'
          }
        : {};
};

const descriptionTitle = (title: string) => (
    <h5
        style={{
            background: '#d9d9d9',
            height: 32,
            margin: 0,
            paddingLeft: 10,
            lineHeight: 2.2,
            fontWeight: 600
        }}
    >
        <TranslateText>{title}</TranslateText>
    </h5>
);

const LeiSeznamPridelenychLei: React.FC<ILeiSeznamPridelenychLei> = ({ data }) => {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const _getKeyValue_ = (key: string) => (obj: Record<string, any>) => obj[key];

    const renderDrzitel = () => {
        if (data?.entity) {
            const dataFormated = {
                ...data?.entity
            };
            delete dataFormated.oid;
            delete dataFormated.otherregistauthorityid;
            delete dataFormated.otherlegalform;
            return (
                <Descriptions
                    size="small"
                    title={descriptionTitle('UDAJE_DRZITEL_LEI')}
                    layout="horizontal"
                    bordered={true}
                >
                    {Object.keys(dataFormated).map((e, i) => {
                        if (e !== 'oid' && e !== 'otherregistauthorityid' && e !== 'otherlegalform') {
                            return e === 'headquartersaddress' ? (
                                <Descriptions.Item
                                    span={3}
                                    label={<TranslateText>DETAILLEI_ADDRESS</TranslateText>}
                                    labelStyle={getBackGroundStyle(i)}
                                    contentStyle={getBackGroundStyle(i)}
                                >
                                    {`${data.entity.headquartersaddress.firstaddressline}, 
                                ${data.entity.headquartersaddress.city}, 
                                ${data.entity.headquartersaddress.postalCode}, 
                                ${data.entity.headquartersaddress.country}`}
                                </Descriptions.Item>
                            ) : (
                                <Descriptions.Item
                                    span={3}
                                    labelStyle={getBackGroundStyle(i)}
                                    contentStyle={getBackGroundStyle(i)}
                                    label={<TranslateText>{`DETAILLEI_${String(e).toUpperCase()}`}</TranslateText>}
                                >
                                    {e.includes('date') ? (
                                        dayjs(_getKeyValue_(e)(data?.entity)).format('DD.MM.YYYY')
                                    ) : e.includes('registrationauthorityid') ? (
                                        (() => {
                                            const rejstirkVals = _getKeyValue_(data.entity.legaljurisdiction)(
                                                leiRejstrikySelect
                                            )
                                                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                                                .filter((u: any) => u.value === data.entity.registrationauthorityid);
                                            return data.entity.otherregistauthorityid ? (
                                                data.entity.otherregistauthorityid
                                            ) : (
                                                <>
                                                    {data.entity.registrationauthorityid} -{' '}
                                                    {rejstirkVals.length > 0 && (
                                                        <TranslateText>{rejstirkVals[0].labelcz}</TranslateText>
                                                    )}
                                                </>
                                            );
                                        })()
                                    ) : e.includes('formcode') ? (
                                        (() => {
                                            const elfVals = _getKeyValue_(data.entity.legaljurisdiction)(
                                                leiElfKodySelect
                                            )
                                                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                                                .filter((u: any) => u.value === data.entity.entitylegalformcode);
                                            return data.entity.otherlegalform ? (
                                                data.entity.otherlegalform
                                            ) : (
                                                <>
                                                    {data.entity.entitylegalformcode} -{' '}
                                                    {elfVals.length > 0 && (
                                                        <TranslateText>{elfVals[0].labelcz}</TranslateText>
                                                    )}
                                                </>
                                            );
                                        })()
                                    ) : e.includes('lei') ? (
                                        <a
                                            target="_blank"
                                            href={`https://search.gleif.org/#/record/${_getKeyValue_(e)(data?.entity)}`}
                                        >
                                            {_getKeyValue_(e)(data?.entity)}
                                        </a>
                                    ) : (
                                        <TranslateText>{_getKeyValue_(e)(data?.entity)}</TranslateText>
                                    )}
                                </Descriptions.Item>
                            );
                        }
                    })}
                </Descriptions>
            );
        }
    };
    const renderRegUdaje = () => {
        if (data?.registration)
            return (
                <Descriptions
                    size="small"
                    title={descriptionTitle('REG_UDAJE_LEI')}
                    layout="horizontal"
                    bordered={true}
                >
                    {Object.keys(data?.registration).map((e, i) => (
                        <Descriptions.Item
                            span={3}
                            labelStyle={getBackGroundStyle(i)}
                            contentStyle={getBackGroundStyle(i)}
                            label={<TranslateText>{`DETAILLEI_${String(e).toUpperCase()}`}</TranslateText>}
                        >
                            {e.includes('date') ? (
                                dayjs(_getKeyValue_(e)(data?.registration)).format(
                                    e === 'lastupdatedate' ? 'DD.MM.YYYY HH:mm' : 'DD.MM.YYYY'
                                )
                            ) : e.includes('managinglou') ? (
                                <a
                                    target="_blank"
                                    href={`https://search.gleif.org/#/record/${_getKeyValue_(e)(data?.registration)}`}
                                >
                                    {_getKeyValue_(e)(data?.registration)}
                                </a>
                            ) : (
                                <TranslateText>{_getKeyValue_(e)(data?.registration)}</TranslateText>
                            )}
                        </Descriptions.Item>
                    ))}
                </Descriptions>
            );
    };

    const renderExceptionInfo = (exceptionData: ILeiDetail['exceptions'][0]) => {
        return (
            <Descriptions
                size="small"
                title={descriptionTitle(exceptionData.exceptioncategory)}
                layout="horizontal"
                bordered={true}
            >
                <Descriptions.Item
                    span={3}
                    labelStyle={getBackGroundStyle(1)}
                    contentStyle={getBackGroundStyle(1)}
                    label={<TranslateText>DETAILLEI_EXCEPTIONREASON</TranslateText>}
                >
                    <TranslateText>{exceptionData.exceptionreason}</TranslateText>
                </Descriptions.Item>
            </Descriptions>
        );
    };

    const renderPrimaFinalni = (relData: ILeiDetail['releationship'][0]) => {
        return (
            <Descriptions
                size="small"
                title={descriptionTitle(relData.relationshiptype)}
                layout="horizontal"
                bordered={true}
            >
                <Descriptions.Item
                    span={3}
                    labelStyle={getBackGroundStyle(0)}
                    contentStyle={getBackGroundStyle(0)}
                    label={<TranslateText>DETAILLEI_ENDNODEID</TranslateText>}
                >
                    <a target="_blank" href={`https://search.gleif.org/#/record/${relData.endnodeid}`}>
                        {relData.endnodeid}
                    </a>
                </Descriptions.Item>
                <Descriptions.Item
                    span={3}
                    labelStyle={getBackGroundStyle(1)}
                    contentStyle={getBackGroundStyle(1)}
                    label={<TranslateText>DETAILLEI_RELATIONSHIPSTATUS</TranslateText>}
                >
                    <TranslateText>{relData.registrationstatus}</TranslateText>
                </Descriptions.Item>
            </Descriptions>
        );
    };

    const renderMatInfo = () => {
        const primaMatka: ILeiDetail['releationship'] = [];
        const primaMatkaException: ILeiDetail['exceptions'] = [];
        const finalniMatka: ILeiDetail['releationship'] = [];
        const finalniMatkaException: ILeiDetail['exceptions'] = [];
        const fondy: ILeiDetail['releationship'] = [];

        data?.releationship.map(e =>
            e.relationshiptype === 'IS_DIRECTLY_CONSOLIDATED_BY'
                ? primaMatka.push(e)
                : e.relationshiptype === 'IS_ULTIMATELY_CONSOLIDATED_BY'
                  ? finalniMatka.push(e)
                  : fondy.push(e)
        );
        data?.exceptions.map(e =>
            e.exceptioncategory === 'DIRECT_ACCOUNTING_CONSOLIDATION_PARENT'
                ? primaMatkaException.push(e)
                : e.exceptioncategory === 'ULTIMATE_ACCOUNTING_CONSOLIDATION_PARENT'
                  ? finalniMatkaException.push(e)
                  : null
        );

        return (
            <>
                {(primaMatka.length > 0 || finalniMatka.length > 0 || (data?.exceptions || []).length > 0) && (
                    <Title
                        level={5}
                        style={{
                            color: '#006866',
                            marginTop: 16
                        }}
                        text="LEI_MATKY_INFO"
                    />
                )}

                {primaMatka.length > 0
                    ? renderPrimaFinalni(primaMatka[0])
                    : primaMatkaException.length > 0
                      ? renderExceptionInfo(primaMatkaException[0])
                      : null}
                {finalniMatka.length > 0
                    ? renderPrimaFinalni(finalniMatka[0])
                    : finalniMatkaException.length > 0
                      ? renderExceptionInfo(finalniMatkaException[0])
                      : null}

                {fondy.length > 0 && (
                    <>
                        <Title
                            level={5}
                            text={
                                fondy[0].relationshiptype !== 'IS_INTERNATIONAL_BRANCH_OF'
                                    ? 'INFO_LEI_FOND'
                                    : 'INFO_LEI_BRANCH'
                            }
                            style={{
                                color: '#006866',
                                marginTop: 16
                            }}
                        />
                        {fondy.map((u: ILeiDetail['releationship'][0]) => (
                            <Descriptions size="small" layout="horizontal" bordered={true}>
                                <Descriptions.Item
                                    span={3}
                                    labelStyle={getBackGroundStyle(0)}
                                    contentStyle={getBackGroundStyle(0)}
                                    label={<TranslateText>DETAILLEI_ENDNODEID</TranslateText>}
                                >
                                    <a target="_blank" href={`https://search.gleif.org/#/record/${u.endnodeid}`}>
                                        {u.endnodeid}
                                    </a>
                                </Descriptions.Item>
                                <Descriptions.Item
                                    span={3}
                                    labelStyle={getBackGroundStyle(1)}
                                    contentStyle={getBackGroundStyle(1)}
                                    label={<TranslateText>DETAILLEI_RELATIONSHIPTYPE</TranslateText>}
                                >
                                    <TranslateText>
                                        {u.relationshiptype === 'IS_FUND-MANAGED_BY'
                                            ? 'IS_FUND_MANAGED_BY'
                                            : u.relationshiptype}
                                    </TranslateText>
                                </Descriptions.Item>
                                <Descriptions.Item
                                    span={3}
                                    labelStyle={getBackGroundStyle(0)}
                                    contentStyle={getBackGroundStyle(0)}
                                    label={<TranslateText>DETAILLEI_RELATIONSHIPSTATUS</TranslateText>}
                                >
                                    <TranslateText>{u.registrationstatus}</TranslateText>
                                </Descriptions.Item>
                            </Descriptions>
                        ))}
                    </>
                )}
            </>
        );
    };
    return (
        <FormWrapper
            onFinish={() => {}}
            name="detail"
            layoutPosition="horizontal"
            size="small"
            labelAlign="left"
            colon={false}
            modalForm={true}
        >
            <Title
                level={5}
                style={{
                    color: '#006866',
                    marginTop: 16
                }}
                text={'REF_DATA_LEI'}
            />
            {renderDrzitel()}
            {renderRegUdaje()}
            {renderMatInfo()}
            <p
                style={{
                    marginTop: 10,
                    fontSize: 14
                }}
            >
                <TranslateText>UDAJE_K_DATU</TranslateText> {dayjs(data?.datelastloaded).format('DD.MM.YYYY HH:mm')}
            </p>
        </FormWrapper>
    );
};

export default LeiSeznamPridelenychLei;
